document.querySelector('#at-show-academy-videos').addEventListener('click', () => {
  document.querySelector('#at-show-academy-videos span').classList.toggle('visually-hidden');
  document.querySelectorAll('.at-academy-video--to-hide').forEach((item) => {
    item.classList.toggle('visually-hidden');
  });
});
